/**
 * MessageWindow object defining the promotion message modal
 *
 * @author Vladimir Dosen <vlada.dosen@gmail.com>
 *
 * @param {Number} i
 * @param {String} n
 * @returns {MessageWindow}
 */


var MessageWindow = function(i, n) {

    var element     =   null;
    var id          =   typeof i !== "undefined" ? i : 0;
    var name        =   typeof n !== "undefined" ? n : '';
    var options     =   {};
    var manager     =   null;
    var behavior    =   null;
    var positioner  =   null;
    var strategy    =   null;

    this.getId = function() {
        return id;
    };
    this.getName = function() {
        return name;
    };
    this.setElement = function(e) {
        element = e;
        return this;
    };
    this.getElement = function() {
        return element;
    };
    this.setOptions = function(o) {
        options = o;
        return this;
    };
    this.getOptions = function() {
        return options;
    };
    this.setManager = function(m) {
        manager = m;
        return this;
    };
    this.getManager = function() {
        return manager;
    };
    this.setBehavior = function(b) {
        behavior = b;
        return this;
    };
    this.getBehavior = function(){
        return behavior;
    };
    this.setPositioner = function(p) {
        positioner = p;
        return this;
    };
    this.getPositioner = function() {
        return positioner;
    };
    this.setStrategy = function(s) {
        strategy = s;
        return this;
    };
    this.getStrategy = function() {
        return strategy;
    };

    this.listener = function(event, element, handler, settings) {
        var self = this;
        $(element).on(event, function(e){handler.call(self, e, settings);});
        return this;
    };

    this.removeListener = function(event, element) {
        $(element).off(event);
        return;
    };

    this.fireEvent = function(event) {
        jQuery(document).trigger(event, this);
        return this;
    };

    this.fireAjax = function(url, params) {
        return $.post(url, params);
    };

    this.position       =   function(){
        this.getPositioner().place();
    };
    this.appear         =   function(){
        this.getBehavior().show();
    };
    this.disappear      =   function(){
        this.getBehavior().hide();
    };

};